export function getGoogleMapsBrowserApiKey(): string {
  return [
    import.meta.env.VITE_GOOGLE_MAPS_BROWSER_API_KEY,
    import.meta.env.VITE_GOOGLE_MAPS_API_KEY,
  ].reduce<string>((apiKey, value) => apiKey || String(value || '').trim(), '')
}

/**
 * The Google Map ID an admin map styles with (Advanced Markers need one). The delivery route map
 * has its own; Google's demo ID stands in when a map's ID isn't configured.
 */
export function getGoogleMapsMapId(map: 'default' | 'deliveryRoute' = 'default'): string {
  const mapId =
    map === 'deliveryRoute'
      ? import.meta.env.VITE_GOOGLE_MAPS_DELIVERY_ROUTE_MAP_ID
      : import.meta.env.VITE_GOOGLE_MAPS_MAP_ID

  return mapId || 'DEMO_MAP_ID'
}
